// src/golive/components/RunStatusBadge.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (map: "golive", see shared/ui/statusMaps.js's `goliveStatusMap`).
// Keeps the `gl-badge {status}` class so golive.css's existing styling
// (colors per status) keeps applying unchanged.
import StatusBadge from "../../shared/ui/StatusBadge";

export default function RunStatusBadge({ status }) {
  return <StatusBadge map="golive" status={status} className={`gl-badge ${status}`} />;
}
